import type { EntityTableAdapter } from './EntityTableAdapter';
import type { ScimEntityService } from '../../../services/ScimEntityService';

export function createSchemaBindingManagementTableAdapter(args: {
    authResolved: boolean;
    entityService: ScimEntityService;
    getSelectedEntityType: () => string;
    pageSize?: number;
}): EntityTableAdapter<any> {
    const { authResolved, entityService, getSelectedEntityType, pageSize = 25 } = args;

    return {
        entityType: 'schemabinding',
        getColumns: () => [],
        loadData: async (page, abortSignal, searchFilter, _selectedType, sortBy) => {
            if (!authResolved) {
                return { data: [], totalResults: 0, currentPage: 1, totalPages: 1, hasNextPage: false, hasPreviousPage: false };
            }

            const selectedEntityType = getSelectedEntityType();
            let effectiveFilter: string | undefined = searchFilter;
            if (selectedEntityType) {
                const entityTypeFilter = `Entity.DisplayName eq "${selectedEntityType}" or Entity.Id eq "${selectedEntityType}"`;
                effectiveFilter = searchFilter ? `(${entityTypeFilter}) and (${searchFilter})` : entityTypeFilter;
            }

            // `getEntitiesByType` already supports abortSignal; return the full response so list-level meta flows through.
            return await entityService.getEntitiesByType(
                'schemabinding',
                page,
                pageSize,
                sortBy,
                effectiveFilter,
                undefined,
                abortSignal
            );
        },
        deleteById: async (id: string) => {
            await entityService.deleteEntity('schemabinding', id);
        }
    };
}

